import vgLogo from "@/assets/vglogo.webp";

interface SiteLogoProps {
  className?: string;
}

export const SiteLogo = ({ className = "h-10 w-auto" }: SiteLogoProps) => (
  <img
    src={vgLogo}
    alt="VG Mart"
    className={`object-contain ${className}`}
    data-testid="site-logo"
  />
);

export default SiteLogo;
